<template>
  <div class="bg-white">
    <div class="action-btn-block p-2 border-b bg-green-200 rounded-md mx-auto container">
      <div class="w-full">
        <div class="flex">
          <router-link class="btn btn-app rounded-none rounded-l-md" to="/">{{ $t('Back') }}</router-link>
          <input type="text" :placeholder="$t('Label string')" v-model="label.string" class="form-input rounded-none" />
          <input type="text" :placeholder="$t('Label title')" v-model="label.title" class="form-input rounded-none" />
          <input :placeholder="$t('Price')" type="number" v-model="label.price" class="form-input rounded-none" />
          <button class="btn btn-app rounded-none rounded-r-md" @click.prevent="print('210mm', '297mm')">{{ $t('Print') }}</button>
        </div>
        <div class="flex mt-2">
          <select class="form-input bg-white rounded-none rounded-l-md" id="barcode_symbology" v-model="label.barcode_symbology">
            <option :value="null" disabled>
              {{ $t('Select an option') }}
            </option>
            <option value="CODE128">CODE128</option>
            <option value="CODE39">CODE39</option>
            <option value="EAN13">EAN13</option>
            <option value="MSI">MSI</option>
          </select>
          <input v-if="!isBatch" type="number" :placeholder="$t('Label copies')" min="1" v-model="label.copies" class="form-input rounded-none" />
          <select class="form-input bg-white rounded-none" id="cols" v-model="label.cols">
            <option :value="null" disabled>
              {{ $t('Select an option') }}
            </option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
          </select>
          <input type="number" :placeholder="$t('Label text size')" max="35" min="5" v-model="label.size" class="form-input rounded-none" />
          <input type="number" :placeholder="$t('Label width')" min="1" max="4" v-model="label.width" class="form-input rounded-none" />
          <input type="number" :placeholder="$t('Label height')" min="5" v-model="label.height" class="form-input rounded-none rounded-r-md" />
        </div>
      </div>
    </div>
    <div class="flex justify-center p-0">
      <loading :status="loading"></loading>
      <template v-if="isBatch">
        <div :class="`grid grid-cols-${label.cols} p-0`">
          <div
            :class="label.has_border ? 'border-l border-t border-dotted border-black' : ''"
            class="text-center text-xs pt-1"
            v-for="(item, index) in getBatchPack"
            :key="index"
            v-if="item"
          >
            <div class="my-0 py-0" v-if="label.title" :style="`font-weight: ${label.label_font_weight}; font-size:${label.size}px`" v-html="label.title"></div>
            <div v-if="label.price > 0" class="my-0 py-0" :style="`font-weight: ${label.label_font_weight}; font-size:${label.size}px`">
              {{ $t('Price') }} : {{ label.price | currency }}
            </div>
            <barcode
              :value="item"
              :format="label.barcode_symbology"
              margin-top="1"
              margin-bottom="1"
              padding-top="0"
              padding-bottom="0"
              :font-size="label.size"
              class="p-0 m-0"
              :width="label.width"
              :height="label.height"
              :display-value="true"
            />
            <div v-if="label.print_appname" class="my-0 py-0" :style="`font-weight: ${label.label_font_weight}; font-size:${appNameSize}px`">{{ appName }}</div>
          </div>
        </div>
      </template>
      <template v-else>
        <div :class="`grid grid-cols-${label.cols} p-0`">
          <div
            :class="label.has_border ? 'border-l border-t border-dotted border-black' : ''"
            class="text-center text-xs pt-1"
            v-for="(item, index) in Number(label.copies)"
            :key="index"
          >
            <div class="my-0 py-0" v-if="label.title" :style="`font-weight: ${label.label_font_weight}; font-size:${label.size}px`" v-html="label.title"></div>
            <div v-if="label.price > 0" class="my-0 py-0" :style="`font-weight: ${label.label_font_weight}; font-size:${label.size}px`">
              {{ $t('Price') }} : {{ label.price | currency }}
            </div>
            <barcode
              :value="label.string"
              :format="label.barcode_symbology"
              margin-top="1"
              margin-bottom="1"
              padding-top="0"
              padding-bottom="0"
              :font-size="label.size"
              class="p-0 m-0"
              :width="label.width"
              :height="label.height"
              :display-value="true"
            />
            <div v-if="label.print_appname" class="my-0 py-0" :style="`font-weight: ${label.label_font_weight}; font-size:${appNameSize}px`">{{ appName }}</div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import VueBarcode from 'vue-barcode';
export default {
  name: 'product-label',
  metaInfo() {
    return {
      titleTemplate: this.$store.getters['app/getAppName'],
    };
  },
  components: { barcode: VueBarcode },
  data() {
    return {
      loading: false,
      printer: {
        width: '50mm',
        height: '250mm',
      },
      label: {
        label_font_weight: 800,
        price: 0,
        title: 'Example name',
        cols: 3,
        barcode_symbology: 'CODE128',
        copies: 10,
        string: '12345678900',
        size: 11,
        width: 1,
        height: 35,
        has_border: true,
        print_imei: true,
        print_appname: true,
      },
    };
  },
  mounted() {
    this.printer = this.getConfigs.paper_size;
    this.label = this.getConfigs.setup;
    if (this.$route.params.id) {
      this.label.string = this.$route.params.id;
    }
    if (this.$route.params.symbology) {
      this.label.barcode_symbology = this.$route.params.symbology;
    }
    if (this.$route.params.title) {
      this.label.title = this.$route.params.title;
    }
    if (this.$route.params.price) {
      this.label.price = this.$route.params.price;
    }
    if (this.$route.params.imei && this.$route.params.imei != 'null' && this.label.print_imei) {
      this.label.string = this.$route.params.imei;
    }
  },
  watch: {
    isBatch(val) {
      if (val) {
        this.label.cols = 1;
      }
    },
  },
  computed: {
    getBatchPack() {
      return this.label.string.split(',');
    },
    isBatch() {
      let str = new String(this.label.string);
      return str.includes(',');
    },
    appNameSize() {
      return window.app.app_name_size ?? 8;
    },
    appName() {
      return this.$store.getters['app/getAppName'];
    },
    getConfigs() {
      return this.$store.getters['app/getSettings'].label_configs;
    },
  },

  methods: {
    print() {
      const element = document.createElement('style');
      element.innerHTML = `@page { margin: 0; size : ${this.printer.width} ${this.printer.height} }`;
      document.head.appendChild(element);
      window.print();
    },
  },
};
</script>
